import { createApi } from "@reduxjs/toolkit/query/react";
import { createRetryingBaseQuery } from "../retryingBaseQuery";

const baseQuery = createRetryingBaseQuery(process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE ?? "");

export const toolAPI = createApi({
  reducerPath: "toolAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetPermissions"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET ALL PERMISSIONS */
    getPermissions: builder.query({
      query: (body: any) => ({
        url: `/permissions/?&page=${body.page}&limit=${body.limit}${
          body.searchAndFilterString || ""
        }`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetPermissions"],
    }),
  }),
});

export const { useLazyGetPermissionsQuery } = toolAPI;
